import React, { useState } from "react";
import { TreatmentItem } from "../../../../../components/treatments/TreatmentItem";
import { Link, useLoaderData, useNavigate, useRevalidator } from "react-router-dom";
import instance, { facUrl } from "../../../../../axios/instance";
import { getToken } from "../../../../../utils/token";
import { SquareArrowOutUpRight } from "lucide-react";
import { toast } from "react-toastify";
import Spinner from "../../../../../components/spinners/Spinner";
import { Back } from "iconsax-react";

export const editTreatmentLoader = async ({ params }) => {
  const token = getToken();
  const res = await instance.get("/doctor/facility", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await instance.get(
    `/doctor/clinic/treatments/${params.id}/${res.data.id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const user = await instance.get("/doctor", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return { treatment: data.data, facility: res.data, user: user.data };
};

export const EditTreatmentPage = () => {
  const { treatment, facility, user } = useLoaderData();
  const [loading, setLoading] = useState(false);
  const revalidator = useRevalidator();
  const navigate = useNavigate();
  const link = facUrl(facility);

  const handleTogglePublish = async () => {
    try {
      const token = getToken();
      setLoading(true);
      await instance.put(
        `/doctor/clinic/treatments/publish/${treatment.id}`,
        { newStatus: treatment.published === "true" ? false : true },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Treatment Updated");
      revalidator.revalidate();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response ? error.response.data.message : "An error occurred"
      );
    }
  };

  const isAdmin = user.access === "admin";

  return (
    <div className="px-7 py-5 w-full">
      <div className="flex justify-between items-center">
        <div className="flex gap-x-2 mb-4 items-center">
          <Back
            size={30}
            onClick={() => isAdmin ? navigate("/dashboard/settings/treatment-setup/treatments") : window.history.back()}
            className="hover:text-primary cursor-pointer"
          />
          <div className="font-medium text-[17px]">
            {isAdmin ? `Update treatment (
            ${treatment.published === "true" ? "Published" : "Unpublished"})` : 'View treatment'}
          </div>
        </div>
        <div className="flex gap-x-3">
          {isAdmin && (
            <button
              onClick={handleTogglePublish}
            className={`w-[150px] px-2 py-2 flex items-center justify-center border ${
              treatment.published === "true"
                ? "bg-[tomato] border-[tomato]"
                : "bg-primary border-primary"
            } 
             text-white text-[14px] font-medium rounded-md`}
          >
            {loading ? (
              <Spinner color="white" />
            ) : treatment.published === "true" ? (
              "Unpublish"
            ) : (
              "Publish"
              )}
            </button>
          )}
          {treatment.published === "true" && (
            <Link
              to={link}
              target="_blank"
              className="px-6 py-2 flex items-center gap-2 border border-primary bg-white text-primary text-[14px] font-medium rounded-md"
            >
              Open <SquareArrowOutUpRight />
            </Link>
          )}
        </div>
      </div>
      <TreatmentItem treatment={treatment} editing={true} isAdmin={isAdmin} />
    </div>
  );
};
